module.exports = __webpack_public_path__ + "static/media/musician-664432_1920.a4f5c239.jpg";